import React, { Fragment, useState } from "react"

import { cancelStockTransferRequest } from "services"
import { Button, ConfirmationModal } from "components"
import classes from "./StrtrCancelButton.module.scss"

const StrtrCancelButton = (props) => {
  const {
    stockTransferRequest,
    setStockTransferRequests
  } = props

  const [sending, setSending] = useState(false)
  const [openCancelConfirmationModal, setOpenCancelConfirmationModal] = useState(false)

  const handleCancelStockTransfer = async () => {
    setSending(true)

    try {
      await cancelStockTransferRequest(
        stockTransferRequest._id
      )

      setStockTransferRequests(prev =>
        prev.map(str =>
          str._id === stockTransferRequest._id
            ? { ...str, stockTransferStatus: "canceled" }
            : str
        )
      )
    } catch (err) {
      console.log(err)

      setSending(false)
    }
  }

  return (
    <Fragment>
      <Button
        onClick={() => setOpenCancelConfirmationModal(true)}
        className={classes["button"]}
        color="danger"
      >
        لغو درخواست
      </Button>
      <ConfirmationModal
        loading={sending}
        title="آیا می خواهید این درخواست را لغو کنید ؟"
        show={openCancelConfirmationModal}
        onConfirm={handleCancelStockTransfer}
        onHide={() => setOpenCancelConfirmationModal(false)}
      />
    </Fragment>
  )
}

export default StrtrCancelButton